import React, { useState } from 'react'
import {
  auth,
  googleProvider,
  signInWithPopup,
  signOut
} from '../firebase'

const ALLOWED_DOMAIN = 'digiadglobal.com'

const Login = ({ onLogin }) => {
  const [error, setError] = useState('')

  const handleGoogleLogin = async () => {
    setError('')
    try {
      const result = await signInWithPopup(auth, googleProvider)
      const signedInEmail = result.user.email || ''

      // Client-side check for a quick error message — this is a UX nicety
      // only, not the security boundary. The backend enforces this
      // independently for any request that actually costs money.
      if (!signedInEmail.toLowerCase().endsWith(`@${ALLOWED_DOMAIN}`)) {
        await signOut(auth)
        setError(`Please sign in with your @${ALLOWED_DOMAIN} account.`)
        return
      }

      onLogin(result.user)
    } catch (err) {
      setError(err.message)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded shadow-md w-full max-w-sm text-center space-y-4">
        <div className="Logo-align">
            <img
          src="https://www.theengage.in/images/log.jpg"
          alt="Logo"
          className="object-contain"
        />
        </div>
        <h2 className="text-2xl font-bold">Sign in to Dashboard</h2>
        {error && <p className="text-red-500 text-sm">{error}</p>}

        <button
          onClick={handleGoogleLogin}
          className="bg-red-500 text-white py-2 w-full rounded hover:bg-red-600"
        >
          Sign in with Google
        </button>
      </div>
    </div>
  )
}

export default Login
